import Axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Toast } from '../../common/message';
import Modal from 'react-modal';
import BugFiexd from '../../pages/Basic/BugFixed';
import { BrowserView, MobileView } from 'react-device-detect';
import NotificationBar from './Components/NotificationBar';
import NavBtnPC from './Components/NavBtnPC';
import packageJson from '../../../package.json'; // 패키지 제이슨의 정보 불러오기

function Nav() {

  const navigate = useNavigate();
  const location = useLocation();
  const [showNav, setShowNav] = useState(false);
  const [popup, setPopup] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  
  // 알림 내용 온오프
  const [Notiflcaption, setNotiflcaption] = useState(false);  
  const [notiflcaptionNoData, setNotiflcaptionNoData] = useState([]);
  const [notiflcaptionSeeData, setNotiflcaptionSeeData] = useState([]);
  const [notiflcaptionCount, setNotiflcaptionCount] = useState(false);
    
  // 게시글 no 데이터 불러오기
  const NotificationNoData = async () => {
    await Axios.get(`/api/notification/nodata`)
    .then((res)=>{
      if(res.data.length)
      {
        setNotiflcaptionNoData(res.data);
      } else {
        setNotiflcaptionNoData([]);
      }
    });
  };
  
  // 게시글 조회 했는지 데이터 불러오기
  const NotificationSeeData = async () => {
    await Axios.get(`/api/notification/seedata`, {
      params: { ID: window.sessionStorage.getItem('basicID') }
    })
    .then((res)=>{
      if(res.data.length)
      {
        setNotiflcaptionSeeData(res.data);
      } else {
        setNotiflcaptionSeeData([]);
      }
    });
  };

  const noticeChack = ()=>{

    NotificationNoData();
    NotificationSeeData();

    let arr1 = [];
    let arr2 = [];
    let arr3 = [];

    // 모든 알림 확인 후 길이가 일치하지 않은지 확인
    notiflcaptionNoData.map((v, i)=>(
      arr1.push(v.no)
    ))
    notiflcaptionSeeData.map((v, i)=>(
      arr2.push(v.i_no)
    ))
    
    arr3.push(arr1.filter(x=>arr2.includes(x)));

    if(arr1.length === arr3[0].length){
      setNotiflcaptionCount(true);
    } else {
      setNotiflcaptionCount(false);
    }
    
    // console.log(notiflcaptionCount);

  };

  useEffect(()=>{

    // DB 버전 불러오기
    const versionLoade = async ()=>{
      await Axios.get(`/api/login/serverVersion`)
      .then((res)=>{
        if(res.data.length)
        {
          if(res.data[0].version !== packageJson.version){
            console.log('업데이트가 가능합니다');
            // window.location.reload()
          } else {
            console.log('최신 버전입니다');
          }
        }
      })
      .catch((err)=>{
        console.log('서버에서 버전을 불러올 수 없습니다');
      });
    }
    // versionLoade();

    // 브라우저 탭 타이틀 지정
    switch(location.pathname){
      case '/login' : document.title = '베이프마켓 - 로그인'; break;
      case '/register' : document.title = '베이프마켓 - 회원가입'; break;
      case '/pointstore' : document.title = '포인트 상점'; break;
      default : break;
    }
    
    // 네비 메뉴 보일지 여부
    if(location.pathname === '/login' || location.pathname === '/register'){
      setShowNav(false);
    } else {
      setShowNav(true);
    }
    
    if(!location.pathname !== '/login' && location.pathname !== '/register')
    {
      session();
      noticeChack();
    }
    
  }, [location.pathname])

  // 세션체크 부분
  const session = async ()=>{
    await Axios.get(`/api/usersession`)
    .then((res)=>{
      if(!res.data.value)
      {

        // 로그인 및 회원가입 창에서는 메시지 미출력
        // if(location.pathname !== '/login' && location.pathname !== '/register'){
        //   Toast.fire({ icon: 'warning', titleText: '세션만료', text: '로그인을 다시 시도해 주세요'})          
        // }

        // window.location.reload();

        // window.location.replace("/")
        
        navigate('/login');
        // window.location.reload();
        
      } else {

        window.sessionStorage.setItem('basicPermission', res.data.permission);
        window.sessionStorage.setItem('basicID', res.data.userid);
        window.sessionStorage.setItem('basicPosition', res.data.position);
        window.sessionStorage.setItem('basicName', res.data.name);
        window.sessionStorage.setItem('basicStore', res.data.store);

        if(location.pathname === '/login' || location.pathname === '/register'){
          // alert('이미 로그인된 상태입니다.');
          navigate('/sale');
        }

      }
    })
    .catch((err)=>{
      Toast.fire({ icon: 'error', titleText: '서버와의 연결이 끊어졌습니다', text: err})
      navigate('/login'); // 오류 발생시 로그인 페이지로 강제 이동
    })

  }

  // 로그아웃 버튼 클릭시
  const useLogOut = async ()=>{

    if(!window.confirm('로그아웃 하시겠습니까?')) return;

    await Axios.get(`/api/deletesession`)
    .then((res)=>{
      if(res.data.value)
      {
        window.sessionStorage.clear(); // 세션 정보 삭제
        console.log('로그아웃 처리: ', res.data.message, '세션이 삭제 되었습니다.');
      } else {
        console.log('로그아웃 처리: ', res.data.message, '세션이 존재하지 않아요.');
      }
      return navigate('/login')
    })
  }

  return (
    showNav ?    
      <div className={``}>
      {/* 버그 제보 버튼 */}
      <div className="fixed justify-center items-center left-[1%] bottom-[1%] z-20 p-5">

        {/* 메인 페이지일 경우 버그 리포트 숨기기 */}
        <div className={`${location.pathname === '/' ? 'hidden' : 'inline'}`}>
          {
            <>
            <BrowserView>
              <Modal isOpen={modalOpen} closeTimeoutMS={150} ariaHideApp={false} onRequestClose={()=>setModalOpen(false)} style={{
              overlay: {
                backgroundColor: 'rgba(30, 30, 30, 0.80)'
              }, 
              content: {
                background: '#424242', 
                border: '2px solid rgba(156, 163, 175)', 
                width: '50%',
                minWidth: '25rem',
                height: '700px',
                margin: 'auto auto'
              }
              }}>
                <BugFiexd/>
              </Modal>

              {/* <div className={
                `text-base cursor-pointer duration-100 hover:scale-95 hidden md:inline
                ${modalOpen ? 'hidden' : 'inline'}`
                }>
                <button
                className='py-2 px-3 outline-none hover:scale-95 bg-blue-600 border-2 rounded-sm border-blue-500/80 hover:border-gray-500/80'
                onClick={()=>setModalOpen(true)}>
                  버그 및 개선 요청
                </button>
              </div> */}

            </BrowserView>

            <MobileView>
              <Modal isOpen={modalOpen} closeTimeoutMS={150} ariaHideApp={false} onRequestClose={()=>setModalOpen(false)} style={{
              overlay: {
                backgroundColor: 'rgba(30, 30, 30, 0.80)'
              }, 
              content: {
                background: '#424242', 
                border: '2px solid rgba(156, 163, 175)', 
                left: '0.5rem', 
                right: '0.5rem'
              }
              }}>
                <BugFiexd/>
              </Modal>
            </MobileView>
            </>
          }
        </div>
      </div>

      {/* PC */}
      <div className={`w-full h-16 overflow-hidden hidden md:visible md:flex md:justify-between md:items-center md:bg-[#3E3E3E] md:rounded-b-md md:shadow-xl whitespace-nowrap overflow-x-auto rounded-b-lg border-b-[1px] border-[#1E1E1E]`}>

        {/* 네비게이션 */}
        <div className='flex gap-1'>

          <NavBtnPC title={'제품판매'} locations={'/sale'} />
          <NavBtnPC title={'판매내역'} locations={'/salelog'} />
          <NavBtnPC title={'재고관리'} locations={'/itemmanagement/itemlist'} />
          <NavBtnPC title={'판매량분석'} locations={'/salechart/chart_1'} />
          <NavBtnPC title={'주문관리'} locations={'/order/order'} />
          <NavBtnPC title={'반출/반입/매입'} locations={'/bcbeme/bc'} />
          <NavBtnPC title={'고객관리'} locations={'/usermanagement'} />
          <NavBtnPC title={'택배/퀵'} locations={'/delivery'} />
          <NavBtnPC title={'통계'} locations={'/statitics'} />
          <NavBtnPC title={'포인트상점'} locations={'/pointstore'} />
          <NavBtnPC title={'사용자관리'} locations={'/storeusermanagement'} />

        </div>

        {/* 사용자 계정 및 로그아웃 */}
        <div className='ml-14 flex right-0 gap-3 p-3 justify-items-center items-center'>
          
          {/* 알림바 */}
          {/* <div className={`duration-100 right-[245px] hidden xl:inline absolute z-[9000] bg-[#2E2E2E] rounded-md cursor-pointer active:scale-95 */}
          <div className={`duration-100  absolute ml-[-58px] z-[9000] bg-[#2E2E2E] rounded-md cursor-pointer active:scale-95
          ${Notiflcaption && 'scale-95'}
          `} >
            <div className={`relative duration-150 hover:font-bold hover:opacity-60 px-3 py-2 ${Notiflcaption && 'opacity-50'}`} onClick={()=>setNotiflcaption(!Notiflcaption)}>
              <p>{Notiflcaption ? '🔕' : '🔔'}</p>
              
              {/* 모든 알림을 읽었을 경우 보이지 않기 */}
              <p className={`absolute right-[-5px] top-[-5px] animate-pulse text-[5px]`}>
                {!notiflcaptionCount && '🔴'}
              </p>
            </div>

            {
            Notiflcaption ?
            <div className='z-[99999] fixed right-0 top-10'>
              <NotificationBar />
            </div>
            :
            null
            }

          </div>


          {/* 사용자 정보 이동 */}
          <p className={`${location.pathname === '/user' && 'font-bold opacity-50'} hover:font-bold duration-150 hover:opacity-50 active:scale-95 cursor-pointer bg-[#2E2E2E] px-3 py-2 rounded-md`} 
          onClick={()=>navigate('/user')}>
            🔥{window.sessionStorage.getItem('basicName')}
          </p>

          {/* 로그아웃 */}
          <Link className={`decoration-pink-400 hover:font-bold duration-150 hover:decoration-4 hover:opacity-60 bg-[#2E2E2E] px-3 py-2 rounded-md`} 
          onClick={useLogOut}>
            🔓 로그아웃
          </Link>
        </div>

      </div>

      {/* mobile */}
      <div className={`md:hidden flex justify-between items-center h-15 bg-[#303030] shadow-xl`}>
          <div className='ml-3'>
            <Link to='/sale' className='text-yellow-400 text-lg cursor-pointer' style={{ fontFamily: 'Nosifer, cursive'}}>
              VapeMarket
            </Link>
          </div>
          <div className='flex gap-3 p-3'>
            {/* 유저 아이콘 */}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer hover:text-yellow-400" 
            onClick={()=>{
              setPopup(false);
              navigate('/user');
            }}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
            </svg>

            {/* 로그아웃 버튼 */}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer hover:text-yellow-400" onClick={useLogOut}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5.636 5.636a9 9 0 1012.728 0M12 3v9" />
            </svg>

            {/* 햄버거 버튼 */}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer hover:text-yellow-400" onClick={()=>{
              popup ? setPopup(false) : setPopup(true);
            }}>
              <path strokeLinecap="round" strokeLinejoin="round" d={popup ? "M6 18L18 6M6 6l12 12" : 'M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5'} />
            </svg>
          </div>
      </div>

      {/* 사이드, 팝업 바 */}
      <div className={popup === false ? 'hidden' : 'inline border-gray-500 md:hidden relative'}>
        <div className='flex flex-col p-5 leading-10 bg-[#1E1E1E]/70 tracking-widest rounded-b-md shadow-lg'>
          <Link onClick={()=>setPopup(false)} className={`${location.pathname === '/sale' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline`} to='/sale'>제품판매</Link>
          <Link onClick={()=>setPopup(false)} className={`${location.pathname === '/salelog' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline`} to='/salelog'>판매내역</Link>
          <Link onClick={()=>setPopup(false)} className={`
            ${location.pathname === '/itemmanagement/itemlist' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
            ${location.pathname === '/itemmanagement/itemlog' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
          `} to='/itemmanagement/itemlist'>재고관리</Link>
          <Link onClick={()=>setPopup(false)} className={`
            ${location.pathname === '/salechart/chart_1' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
            ${location.pathname === '/salechart/chart_2' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
            `} to='/salechart/chart_1'>판매량분석</Link>
          <Link onClick={()=>setPopup(false)} className={`
            ${location.pathname === '/order/order' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
            ${location.pathname === '/order/list' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
            ${location.pathname === '/order/state' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
          `} to='/order/order'>주문관리</Link>
          <Link onClick={()=>setPopup(false)} className={`
            ${location.pathname === '/bcbeme/bc' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
            ${location.pathname === '/bcbeme/be' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
            ${location.pathname === '/bcbeme/me' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
            ${location.pathname === '/bcbeme/cancel' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline
          `} to='/bcbeme/bc'>반출/반입/매입</Link>
          <Link onClick={()=>setPopup(false)} className={`${location.pathname === '/usermanagement' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline`} to='/usermanagement'>고객관리</Link>
          <Link onClick={()=>setPopup(false)} className={`${location.pathname === '/delivery' && 'decoration-yellow-400 font-bold decoration-4 underline'} hover:underline`} to='/delivery'>택배/퀵</Link>
          <Link onClick={()=>setPopup(false)} className={`${location.pathname === '/statitics' && 'decoration-yellow-400 font-bold decoration-4 underline'} duration-150 active:scale-95 hover:opacity-80`} to='/statitics'>통계</Link>
          <Link onClick={()=>setPopup(false)} className={`${location.pathname === '/pointstore' && 'decoration-yellow-400 font-bold decoration-4 underline'} duration-150 active:scale-95 hover:opacity-80`} 
          to='/pointstore'>포인트상점</Link>
          <Link onClick={()=>setPopup(false)} className={`${location.pathname === '/storeusermanagement' && 'decoration-yellow-400 font-bold decoration-4 underline'} ${window.sessionStorage.getItem('basicPermission') < 4 && 'hidden'} hover:underline text-yellow-500`} to='/storeusermanagement'>사용자관리</Link>
        </div>        
      </div>

      {/* 모바일 퀵 버튼 */}
      <div className="md:hidden fixed right-[1%] bottom-[1%] z-10 p-5">
        <ul className={`grid gap-3 ${modalOpen ? 'hidden' : 'inline'}`}>
          {/* 버그 및 개선요청 */}
          {/* <li className={
            `text-base cursor-pointer duration-100 hover:scale-95
            ${modalOpen ? 'hidden' : 'inline'}`
            }>
            <button
            className='bg-blue-500/90 rounded-[50%] p-1 border-[1px] border-gray-500 shadow-xl text-white w-10 h-10 cursor-pointer'
            onClick={()=>setModalOpen(true)}>
              🧪
            </button>
          </li> */}
          {/* 새로고침 */}
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="bg-blue-500 rounded-[50%] p-1 border-[1px] border-gray-500 shadow-xl text-white w-10 h-10 cursor-pointer" onClick={()=>{
              window.location.reload();
            }}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
          </li>
          {/* 상단 */}
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="bg-blue-500 rounded-[50%] p-1 border-[1px] border-gray-500 shadow-xl text-white w-10 h-10 cursor-pointer" onClick={()=>{
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              })
            }}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75" />
            </svg>
          </li>
        </ul>
      </div>

      </div>
    :
    null
  )
}

export default Nav